import axios from "axios";
import { API_URL } from "const/constants";

export const getCaseOfficerHistory = async (clientId) => {
  const { data } = await axios.get(`${API_URL}/clients/${clientId}/case-officer/history`);
  return data?.data?.content ?? data?.data ?? data;
};
